// extracted by mini-css-extract-plugin
export default {"Logo":"AppLogo_Logo__eMTaN"};